import { useCallback, useEffect, useState } from 'react';
import { message } from 'antd';
import { FIND, FIND_KEY, process } from '../Service/Api';

export const useFetchUsesCFDI = (queries = '', skip = 0, limit = 10) => {
  const [data, setData] = useState({ data: [] });
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState({ queries, limit, skip });

  const getUsesCFDI = useCallback(async () => {
    setLoading(true);
    const response = await process(FIND, 'invoice-uses', {}, params);
    if (response?.ok) {
      setData(response.data);
    } else {
      message.error('Error al consultar Usos del CFDI');
    }
    setLoading(false);
  }, [process, params]);

  useEffect(() => {
    getUsesCFDI();
  }, [getUsesCFDI]);

  const onChangeParams = (q = '', s = 0, l = 10) =>
    setParams({ queries: q, limit: l, skip: s });

  const update = () => getUsesCFDI();

  return [data, loading, onChangeParams, update];
};

export const useFetchUsesCFDIWithApiKey = (
  queries = '',
  skip = 0,
  limit = 10
) => {
  const [data, setData] = useState({ data: [] });
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState({ queries, limit, skip });

  const getUsesCFDI = useCallback(async () => {
    setLoading(true);
    const response = await process(FIND_KEY, 'invoice-uses', {}, params);
    if (response?.ok) {
      setData(response.data);
    } else {
      message.error('Error al consultar Usos del CFDI');
    }
    setLoading(false);
  }, [process, params]);

  useEffect(() => {
    getUsesCFDI();
  }, [getUsesCFDI]);

  const onChangeParams = (q = '', s = 0, l = 10) =>
    setParams({ queries: q, limit: l, skip: s });

  const update = () => getUsesCFDI();

  return [data, loading, onChangeParams, update];
};
